import API from 'services/api';

export const getAllProperties = () => API.get(`/api/accommodation/properties/all`);
